import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForLiveEventsComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'customFilter',
      type: 'selectCustom',
      options: [
        { property: 'secret', value: 1 },
        { property: 'tbc', value: 1 },
        { property: 'dgg', value: 1 },
        { property: 'dggGas', value: 1 },
      ],
    },
    {
      key: 'startDate_gte',
      type: 'date',
    },
    {
      key: 'startDate_lte',
      type: 'date',
    },
  ];

  defaultColumns = [
    'id',
    'displayHeadline',
    'startDate',
    'artists.name',
    'locationPartners.name',
    'locationPartners.city',
    'type.name',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'displayHeadline',
      isMainColumn: true,
      isTruncate: true,
    },
    {
      property: 'startDate',
      sortable: true,
      type: 'date',
      format: 'L',
      align: 'right',
      isLinkToDetail: true,
    },
    {
      property: 'artists.name',
      relationProperty: 'artists',
      relationLabel: 'displayLabel',
      sortable: true,
      type: 'relation',
    },
    {
      property: 'locationPartners.name',
      relationProperty: 'locationPartners',
      relationLabel: 'name',
      sortable: true,
      type: 'relation',
    },
    {
      property: 'locationPartners.country',
      relationProperty: 'locationPartners',
      relationLabel: 'country.displayLabel',
      sortable: true,
      type: 'relation',
    },
    {
      property: 'locationPartners.city',
      relationProperty: 'locationPartners',
      relationLabel: 'city',
      sortable: true,
      type: 'relation',
    },
    {
      property: 'presenterPartners',
      relationLabel: 'name',
      type: 'relation',
    },
    {
      property: 'type.name',
      relationProperty: 'type',
      relationLabel: 'name',
      sortable: true,
      type: 'relation',
    },
    {
      property: 'repertoire',
      sortable: true,
      type: 'sanitize-html',
    },
    {
      property: 'internalRemarks',
      sortable: true,
      type: 'sanitize-html',
    },
    {
      property: 'text',
      sortable: true,
      type: 'sanitize-html',
    },
    {
      property: 'secret',
      sortable: true,
    },
    {
      property: 'tbc',
      sortable: true,
    },
    {
      property: 'ticketAvailability',
      sortable: true,
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
